import { useEffect } from "react";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { ObjectHelper } from "../../utils/ObjectHelper";
import { enmStopFreeSaleReportTypes } from "../../models/enums/StopFreeSaleReportTypes";

export type StopFreeSaleReportTypeSelectProps = {
    onChange?: Function;
    value?: any;
    mode?: "multiple" | "tags" | undefined;
    specificTypes?: enmStopFreeSaleReportTypes[];
}

export const StopFreeSaleReportTypeSelect = (props: StopFreeSaleReportTypeSelectProps) => {
    const { t } = useTranslation();

    useEffect(() => {
    }, [props]);

    let items: { name: string; id: number }[] = props.specificTypes ? ObjectHelper.getEnumKeyValuesForSpecificTypes(enmStopFreeSaleReportTypes, props.specificTypes) : ObjectHelper.enumToObjectArray(enmStopFreeSaleReportTypes);

    return (
        <>
            <Select
                mode={props.mode}
                size="middle"
                value={props.mode == "multiple" ? props.value as string[] : props.value as string}
                onChange={(value: string | string[]) => props.onChange ? props.onChange(value) : undefined}
                showSearch
                placeholder={t("common.choose")}
                filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                options={items?.map(h => Object.assign(h, {
                    label: h.name,
                    value: h.id
                }))}
            />
        </>
    )
}